import React from 'react';
import Campo from './Campo';

/** Selecao — lista de uma escolha, com rótulo visível. opcoes: [{ valor, rotulo }]. */
export default function Selecao({ rotulo, ajuda, erro, opcoes, valor, onMudar, disabled = false }) {
  return (
    <Campo rotulo={rotulo} ajuda={ajuda} erro={erro}>
      {(p) => (
        <span className="sj-campo__selecao">
          <select {...p} className="sj-campo__entrada" value={valor} disabled={disabled} onChange={(e) => onMudar?.(e.target.value)}>
            {opcoes.map((o) => <option key={o.valor} value={o.valor}>{o.rotulo}</option>)}
          </select>
          <span className="sj-icone" aria-hidden="true">expand_more</span>
        </span>
      )}
    </Campo>
  );
}
